(function() {
  'use strict';
  eclipseApp.directive('rgAddress', function() {
    return {
      restrict: 'AE',
      scope: {
        address: '=',
        multiLine: '=?',
        showCountry: '=?',
        serviceMultiAddress: '=?'
      },
      //template: '<span>{{address.Street}}</span>',
      template:
        '<span ng-if="address.SubBuilding && address.showUnitFirst">{{address.SubBuilding}}-</span>{{address.Street}}<span ng-show="displayMultipleLine"><br></span><span ng-if="!displayMultipleLine">, </span>{{address.City}} {{address.Province}} &nbsp;{{address.PostalCode}}<span ng-if="displayCountry"> {{address.Country}}</span><span ng-if="address.SubBuilding && !address.showUnitFirst"> #{{address.SubBuilding}}</span>',
      link: function(scope) {
        // TODO: DEFINE USE CASES AND FEATURES
        scope.bindAddress = function() {
          // if address has streetNumber, it's not Canada Post address object, but it's our own address object, so we need to change it to Canada Post style object.
          //
          if (scope.address && (scope.address.streetNumber || scope.address.StreetNumber)) {
            scope.address.SubBuilding = scope.address.unitNumber ? scope.address.unitNumber : false;

            if (scope.serviceMultiAddress === true) {
              scope.address.showUnitFirst = false;
            } else {
              scope.address.showUnitFirst = true;
            }
            if (typeof scope.address.streetNumberSuffix === 'undefined') {
              scope.address.streetNumberSuffix = '';
            }
            scope.address.Street = scope.address.streetNumber
              ? // handle ss response
                (scope.address.streetNumber ? _.capitalize(scope.address.streetNumber) : scope.address.streetNumber) +
                (scope.address.streetNumberSuffix
                  ? _.capitalize(scope.address.streetNumberSuffix)
                  : scope.address.streetNumberSuffix) +
                ' ' +
                (scope.address.streetName
                  ? _.capitalize(scope.address.streetName.toLowerCase())
                  : scope.address.streetName) +
                ' ' +
                (scope.address.streetType
                  ? _.capitalize(scope.address.streetType.toLowerCase())
                  : scope.address.streetType) +
                ' ' +
                (scope.address.streetDirection
                  ? _.capitalize(scope.address.streetDirection.toLowerCase())
                  : scope.address.streetDirection)
              : // handle pca response
                scope.address.StreetNumber +
                '' +
                scope.address.streetNumberSuffix +
                ' ' +
                scope.address.StreetName +
                ' ' +
                scope.address.StreetType +
                ' ' +
                scope.address.streetDirection;

            scope.address.City = scope.address.city
              ? // handle ss response
                scope.address.city
                ? _.capitalize(scope.address.city.toLowerCase())
                : scope.address.city
              : // handle pca response
              scope.address.City
              ? _.capitalize(scope.address.City.toLowerCase())
              : scope.address.City;

            scope.address.Province = scope.address.province ? scope.address.province : scope.address.Province;
            scope.address.PostalCode = scope.address.postalCode ? scope.address.postalCode : scope.address.PostalCode;
            scope.address.Country = scope.address.country ? scope.address.country : scope.address.Country;

            scope.displayMultipleLine = angular.isDefined(scope.multiLine) ? scope.multiLine : true;
            scope.displayCountry = angular.isDefined(scope.showCountry) ? scope.showCountry : false;
          }
        };

        // if address is undefined, attach watcher for future update.
        /*      if(!scope.address)
              {
        */
        scope.$watch(
          'address',
          function(newValue, oldValue) {
            scope.bindAddress();
          },
          true
        );
        /*  }
          else
            scope.bindAddress();
        */
      }
    };
  });
})();
